import { GuardPayrollRecord, ConsultantPayrollRecord, DateGroupRow, ShiftDetailRow } from 'containers/pages/payrollReport/types';
import { formatDate, formatTime, decimalToHourMin } from './dateUtils';
import { calculateGuardTotalHours, calculateConsultantHours } from './calculateHours';

/**
 * Maps grouped guard records into DateGroupRow[] for table rendering.
 */
export const mapGuardTableData = (
  groups: Record<string, GuardPayrollRecord[]>,
): DateGroupRow[] => {
  return Object.entries(groups)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([date, records]) => {
      const children: ShiftDetailRow[] = records.map((r, idx) => ({
        id: `${date}-shift-${idx}`,
        startTime: formatTime(r.StartTime),
        endTime: formatTime(r.EndTime),
        address: r.Address,
        customerName: r.CustomerName,
      }));

      return {
        id: date,
        date,
        formattedDate: formatDate(date),
        totalHours: calculateGuardTotalHours(records),
        children,
      };
    });
};

/**
 * Maps grouped consultant records into DateGroupRow[] for table rendering.
 */
export const mapConsultantTableData = (
  groups: Record<string, ConsultantPayrollRecord[]>,
): DateGroupRow[] => {
  return Object.entries(groups)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([date, records]) => {
      const { regularTime, overTime } = calculateConsultantHours(records);

      const children: ShiftDetailRow[] = records.map((r) => ({
        id: `${date}-comment-${r.CommentId}`,
        regularTime: decimalToHourMin(parseFloat(r.CommentTimeRegular || '0')),
        overTime: decimalToHourMin(parseFloat(r.CommentTimeOver || '0')),
        caseTitle: r.CaseTitle,
        customerName: r.CustomerName,
      }));

      return {
        id: date,
        date,
        formattedDate: formatDate(date),
        totalHours: '',
        totalHoursRT: regularTime,
        totalHoursOT: overTime,
        children,
      };
    });
};
